import { TLinkField } from '../types/types';

export function targetLinkdsk(link: TLinkField | undefined, isDesktop?: boolean): string {
  if (isDesktop && link?.value?.target) {
    return link?.value?.target;
  } else if (!isDesktop && link?.value?.target) {
    return '_self';
  } else return '';
}
